/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewServiceAccountDTO
 */
export interface NewServiceAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof NewServiceAccountDTO
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewServiceAccountDTO
     */
    isAdmin?: boolean;
}

/**
 * Check if a given object implements the NewServiceAccountDTO interface.
 */
export function instanceOfNewServiceAccountDTO(value: object): value is NewServiceAccountDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NewServiceAccountDTOFromJSON(json: any): NewServiceAccountDTO {
    return NewServiceAccountDTOFromJSONTyped(json, false);
}

export function NewServiceAccountDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewServiceAccountDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isAdmin': json['isAdmin'] == null ? undefined : json['isAdmin'],
    };
}

export function NewServiceAccountDTOToJSON(value?: NewServiceAccountDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'isAdmin': value['isAdmin'],
    };
}

